import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'

import { Link } from 'tools/Link'
import {
  ActionTable,
  ActionTableBody as Atbody,
  ActionTableCell as Atd,
  ActionTableHeadCell as Ath,
  ActionTableHeading as Athead
} from 'tools/Table/Action'
import { MaxViewPage } from 'tools/Uniform'
import { cleanPath } from 'utils/string'

import paths from 'hub/paths'
import GlobalContext from 'reducer/global'

import Create from '../Create'

export default function List() {
  const [{ user, org: activeOrg }] = useContext(GlobalContext)
  const count = user.orgMemberships.length
  const activeOrgId = activeOrg.id //|| user.orgMemberships?.[0]?.org?.id

  return (
    <MaxViewPage>
      {count === 0 ? (
        <>
          <label>You are not currently a member of any organization.</label>
          <div className="i gray mv3">
            An organization account is required to register services. It is where
            you setup your payment method.
            <p />
            You can have multiple people in a single organization, and you can be
            a member of mulitiple organizations.
          </div>
          <div className="mt5">
            <h1 className="mb3">Create Organization</h1>
          </div>
        </>
      ) : (
        <>
          <h1 className="mb3">Your Organization Account{count > 1 && 's'}</h1>
          <div className="i gray mb3">
            You may choose an active account here, which is what's referenced when
            looking into other resources on this console.
          </div>
          <ActionTable className="w-100">
            <Athead>
              <Ath>Active</Ath>
              <Ath className="ph2 tl">Name</Ath>
              <Ath className="ph2 tl">ID</Ath>
              <Ath className="ph2 tl">Role</Ath>
            </Athead>
            <Atbody>
              {user.orgMemberships.map((m) => (
                <OrgRow
                  active={activeOrgId === m.org.id}
                  org={m.org}
                  role={m.role}
                  key={m.id}
                />
              ))}
              {activeOrgId && !user.isMemberOfActiveOrg && (
                <OrgRow
                  active={true}
                  org={activeOrg}
                  role={
                    <>
                      superadmin <i className="fa fa-key pl2 f2" />
                    </>
                  }
                />
              )}
            </Atbody>
          </ActionTable>
        </>
      )}
      <Create />
    </MaxViewPage>
  )
}

function OrgRow({ active, org, role }) {
  const history = useHistory()
  return (
    <Link
      type="tr"
      to={`/org/${org.shortId}/settings`}
      className={`pointer ${active ? 'bg-hilite' : ''}`}
    >
      <Atd
        onClick={(ev) => {
          ev.stopPropagation()
          ev.preventDefault()
          const url = cleanPath(paths.public.org, org.shortId, 'orgs')
          history.push(url)
        }}
        className="tc w3"
      >
        {active ? (
          <i className="fas fa-square-check primary" />
        ) : (
          <i className="fas fa-square gray" />
        )}
      </Atd>
      <Atd>{org.name}</Atd>
      <Atd>{org.shortId}</Atd>
      <Atd>{role}</Atd>
    </Link>
  )
}
